module.exports = __webpack_public_path__ + "static/media/icon-prev.9b73d107.svg";